module.exports = __webpack_public_path__ + "1eee2cf391fcd0b6e7836baf4d25bb5a.svg";